export const ENDPOINTS = {
  getBookings: '/gateway/admin/bookings',
  getBooking: '/gateway/admin/bookings/:bookingCode',
  updateBooking: '/gateway/admin/bookings/:bookingCode',
  cancelBooking: '/gateway/admin/bookings/:bookingCode/cancel',
  getPaymentReceipt: '/gateway/admin/bookings/:bookingCode/payment-receipt',
  generatePaymentReceipt:
    '/gateway/admin/bookings/:bookingCode/payment-receipt',
  getBookingRefund: '/gateway/admin/bookings/:bookingCode/refund',
  createBookingRefund: '/gateway/admin/bookings/:bookingCode/refund',
  createBookingVoucher: '/gateway/admin/bookings/:bookingCode/voucher',
  updateOrDeleteBookingVoucher:
    '/gateway/admin/bookings/:bookingCode/voucher/:voucherCode',
  resendUserMail: '/gateway/admin/bookings/:bookingCode/emails/user',
  resendHotelMail: '/gateway/admin/bookings/:bookingCode/emails/hotel',
} as const;

export const CORE_QUERY_KEYS = {
  bookings: 'admin-bookings',
  booking: 'admin-booking',
  bookingRefund: 'admin-booking-refund',
} as const;
